import React, { useRef } from "react";
import ReactToPrint from 'react-to-print';
import { PhieuIn } from './PhieuIn';

export const BtnIn = ({ item }) => {
    const componentToPrintRef = useRef();

    return (
        <>
            <ReactToPrint
                trigger={() => (
                    <a type="button" className="popover-basic" style={{ cursor: 'pointer' }}>
                        <img src="/app-assets/images/icon-in-phieu-chenh-lech.png" title="In phiếu"/>
                    </a>
                )}
                content={() => componentToPrintRef.current}
            />
            <div style={{ display: "none" }}>
                <PhieuIn ref={componentToPrintRef} item={item} />
            </div>
        </>
    );
};